import { t } from 'i18next';

import styles from './EmployerPortalJobs.module.css';
import { getTimeAgo } from '../../../../utils/formatHelpers';

import moment from 'moment';

export const datePostedUI = (item) => {
    if (item.createdAt) {
        const date_info = getTimeAgo(new Date(item.createdAt));
        let last_seen = '';
        let is_online = false;

        if (date_info.unit_plural !== 'month' && date_info.unit_plural !== 'months' && date_info.unit_plural !== 'year' && date_info.unit_plural !== 'years') {
            if (date_info.unit_plural === 'second' || date_info.unit_plural === 'seconds' || date_info.unit_plural === 'minute' || (date_info.unit_plural === 'minutes' && date_info.count < 5)) {
                last_seen = t('general.UI.online');
                is_online = true;
            }
            else {
                last_seen = date_info.count + ' ' + t('general.UI.' + date_info.unit_plural) + ' ' + t('general.UI.ago');
            }
        }
        return (
            <>
                <p className={styles.datePosted}>{moment(item.createdAt).format('ll')}</p>
                <p className={styles.datePosted}>{last_seen}</p>
            </>
        )
    };
};
